import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export default function VendorTable() {
  const [vendors, setVendors] = useState([
    {
      id: 1,
      name: 'ABC Traders',
      email: 'abc@traders.com',
      mobile: '9876543210',
      address: 'Chandni Chowk',
      state: 'Delhi',
      city: 'New Delhi',
    },
    {
      id: 2,
      name: 'XYZ Supplies',
      email: 'xyz@supplies.com',
      mobile: '9988776655',
      address: 'Andheri East',
      state: 'Maharashtra',
      city: 'Mumbai',
    },
  ]);

  const [showModal, setShowModal] = useState(false);
  const [editingVendor, setEditingVendor] = useState(null);
  const [newVendor, setNewVendor] = useState({
    name: '',
    email: '',
    mobile: '',
    address: '',
    state: '',
    city: '',
  });
  const [search, setSearch] = useState('');

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6;
  const filtered = vendors.filter(
    (v) =>
      v.name.toLowerCase().includes(search.toLowerCase()) ||
      v.email.toLowerCase().includes(search.toLowerCase()) ||
      v.city.toLowerCase().includes(search.toLowerCase())
  );
  const totalPages = Math.ceil(filtered.length / itemsPerPage);
  const currentData = filtered.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleSave = () => {
    if (newVendor.name && newVendor.email) {
      if (editingVendor) {
        // Update vendor
        setVendors(
          vendors.map((v) =>
            v.id === editingVendor.id ? { ...editingVendor, ...newVendor } : v
          )
        );
      } else {
        // Add vendor
        setVendors([...vendors, { id: Date.now(), ...newVendor }]);
      }
      setNewVendor({
        name: '',
        email: '',
        mobile: '',
        address: '',
        state: '',
        city: '',
      });
      setEditingVendor(null);
      setShowModal(false);
    }
  };

  const handleEdit = (vendor) => {
    setEditingVendor(vendor);
    setNewVendor(vendor);
    setShowModal(true);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-white via-blue-50 to-blue-100 p-10 text-gray-900">
      {/* Header */}
      <div className="flex items-center justify-between mb-10">
        <h1 className="text-4xl font-extrabold text-blue-800 tracking-tight">
          👨‍💼 Vendor Management
        </h1>
        <button
          onClick={() => {
            setEditingVendor(null);
            setNewVendor({
              name: '',
              email: '',
              mobile: '',
              address: '',
              state: '',
              city: '',
            });
            setShowModal(true);
          }}
          className="bg-blue-600 hover:bg-blue-700 text-white px-7 py-3 text-lg rounded-2xl shadow-lg transition-all duration-200 font-semibold"
        >
          + Add New
        </button>
      </div>

      {/* Search Bar */}
      <div className="mb-8">
        <input
          type="text"
          placeholder="🔍 Search vendors..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="w-full px-5 py-3 text-lg border rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>

      {/* Table */}
      <motion.div
        initial={{ opacity: 0, y: 15 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className="overflow-hidden rounded-2xl shadow-2xl border bg-white"
      >
        <div className="overflow-x-auto">
          <table className="w-full text-left border-collapse">
            <thead className="bg-gray-100 border-b border-gray-200">
              <tr>
                {[
                  '#',
                  'Vendor Name',
                  'Email',
                  'Mobile',
                  'Address',
                  'State',
                  'City',
                  'Actions',
                ].map((head) => (
                  <th
                    key={head}
                    className="py-4 px-6 text-left text-sm font-semibold text-gray-600 uppercase tracking-wider"
                  >
                    {head}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-100">
              {currentData.map((item, idx) => (
                <motion.tr
                  key={item.id}
                  className="hover:bg-gray-50 transition-colors duration-200"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: idx * 0.05 }}
                >
                  <td className="py-4 px-6 text-sm text-gray-700">
                    {idx + 1 + (currentPage - 1) * itemsPerPage}
                  </td>
                  <td className="py-4 px-6 text-sm font-medium text-gray-900">{item.name}</td>
                  <td className="py-4 px-6 text-sm text-gray-700">{item.email}</td>
                  <td className="py-4 px-6 text-sm text-gray-700">{item.mobile}</td>
                  <td className="py-4 px-6 text-sm text-gray-700">{item.address}</td>
                  <td className="py-4 px-6 text-sm text-gray-700">{item.state}</td>
                  <td className="py-4 px-6 text-sm text-gray-700">{item.city}</td>
                  <td className="py-4 px-6 text-sm">
                    <button
                      onClick={() => handleEdit(item)}
                      className="px-4 py-2 rounded-lg bg-blue-500 hover:bg-blue-600 text-white font-medium shadow-sm transition"
                    >
                      ✏️ Edit
                    </button>
                  </td>
                </motion.tr>
              ))}
              {currentData.length === 0 && (
                <tr>
                  <td
                    colSpan="8"
                    className="text-center py-10 text-gray-500 font-medium text-lg"
                  >
                    🚫 No vendors found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </motion.div>

      {/* Pagination */}
      <div className="flex justify-between items-center mt-8 text-lg">
        <button
          disabled={currentPage === 1}
          onClick={() => setCurrentPage(currentPage - 1)}
          className="px-5 py-2 bg-blue-200 hover:bg-blue-300 disabled:opacity-40 rounded-lg font-medium"
        >
          ⬅ Previous
        </button>
        <span className="text-gray-700 font-semibold">
          Page {currentPage} of {totalPages || 1}
        </span>
        <button
          disabled={currentPage === totalPages || totalPages === 0}
          onClick={() => setCurrentPage(currentPage + 1)}
          className="px-5 py-2 bg-blue-200 hover:bg-blue-300 disabled:opacity-40 rounded-lg font-medium"
        >
          Next ➡
        </button>
      </div>

      {/* Modal */}
      <AnimatePresence>
        {showModal && (
          <motion.div
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.div
              className="bg-white rounded-2xl p-10 w-[700px] max-h-[90vh] shadow-2xl overflow-y-auto text-lg"
              initial={{ scale: 0.85, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.85, opacity: 0 }}
              transition={{ duration: 0.3 }}
            >
              <h2 className="text-3xl font-bold mb-8 text-blue-700">
                {editingVendor ? '✏️ Edit Vendor' : '➕ Add Vendor'}
              </h2>

              <div className="grid grid-cols-2 gap-6">
                {[
                  { placeholder: 'Vendor Name', key: 'name' },
                  { placeholder: 'Email', key: 'email', type: 'email' },
                  { placeholder: 'Mobile', key: 'mobile' },
                  { placeholder: 'Address', key: 'address' },
                ].map((field) => (
                  <input
                    key={field.key}
                    type={field.type || 'text'}
                    placeholder={field.placeholder}
                    value={newVendor[field.key]}
                    onChange={(e) =>
                      setNewVendor({
                        ...newVendor,
                        [field.key]: e.target.value,
                      })
                    }
                    className="border p-4 rounded-lg text-lg shadow-sm focus:ring-2 focus:ring-blue-500"
                  />
                ))}

                <select
                  value={newVendor.state}
                  onChange={(e) =>
                    setNewVendor({ ...newVendor, state: e.target.value })
                  }
                  className="border p-4 rounded-lg text-lg shadow-sm focus:ring-2 focus:ring-blue-500"
                >
                  <option value="">Select State</option>
                  <option>Delhi</option>
                  <option>Maharashtra</option>
                  <option>Karnataka</option>
                </select>

                <select
                  value={newVendor.city}
                  onChange={(e) =>
                    setNewVendor({ ...newVendor, city: e.target.value })
                  }
                  className="border p-4 rounded-lg text-lg shadow-sm focus:ring-2 focus:ring-blue-500"
                >
                  <option value="">Select City</option>
                  <option>New Delhi</option>
                  <option>Mumbai</option>
                  <option>Bengaluru</option>
                </select>
              </div>

              <div className="flex justify-end gap-4 mt-10">
                <button
                  onClick={() => {
                    setShowModal(false);
                    setEditingVendor(null);
                  }}
                  className="px-6 py-3 rounded-xl bg-gray-300 hover:bg-gray-400 font-semibold"
                >
                  Cancel
                </button>
                <button
                  onClick={handleSave}
                  className="px-6 py-3 rounded-xl bg-blue-600 hover:bg-blue-700 text-white font-semibold shadow-lg"
                >
                  Save
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
